module.exports = __webpack_public_path__ + "static/img/14000481.b853f4e4.png";